export const ADD_PRODUCT_TO_LIST = "simplified_sharing_products/ADD_PRODUCT_TO_LIST"

export const REMOVE_PRODUCT_FROM_LIST = "simplified_sharing_products/REMOVE_PRODUCT_FROM_LIST"

export const REMOVE_ALL_PRODUCTS_FROM_LIST = "simplified_sharing_products/REMOVE_ALL_PRODUCTS_FROM_LIST"

export const UPDATE_CUSTOM_MESSAGE = "simplified_sharing_products/UPDATE_CUSTOM_MESSAGE"
